exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4[data-v-5b95079c]{font-size:1.2rem;letter-spacing:.02rem;padding:16px 22px;border-bottom:1px solid #f2f2f2}.card-content *[data-v-5b95079c]{color:#333}button[data-v-5b95079c]{color:#fff!important;font-size:1.2rem}", ""]);

// exports
